import { css } from 'styled-components';

const sectionWrapperStyle = css`
  display: flex;
  flex-direction: column;
  height: 100%;

  .section__wrapper {
    height: 100%;
    flex: 1;
    display: flex;
    overflow: hidden;
  }

  .section__content {
    flex: 1;
    overflow: hidden auto;
    position: relative;
  }

  .error {
    background-color: var(--error100);
    color: var(--error900);
    font-weight: bold;
    padding: 16px;
  }
`;

export { sectionWrapperStyle };
